import { ThemeConfig } from '../types/theme'

export const themeTokens: ThemeConfig = {
  dark: {
    bg: 'bg-[#0F0F0F]',
    card: 'bg-[#1A1A1A]/80 backdrop-blur-3xl border border-white/[0.08]',
    text: 'text-[#E8E8E6]',
    shadow: 'shadow-2xl shadow-black/40',
    accent: 'text-[#C8956C]',
    border: 'border-white/[0.08]',
  },
  light: {
    bg: 'bg-[#FAFAF8]',
    card: 'bg-white/80 backdrop-blur-3xl border border-black/[0.08]',
    text: 'text-[#1A1A1A]',
    shadow: 'shadow-2xl shadow-black/[0.04]',
    accent: 'text-[#C8956C]',
    border: 'border-black/[0.06]',
  },
}
